declare const APP_VERSION: string | undefined;

export function getVersion() {
  return typeof APP_VERSION !== "undefined" ? APP_VERSION : undefined;
}
